import * as std from '@nx/stdlib';

const GQL_STATUS_INDEXES = {
  title: 1,
  description: 2,
};

const formatPropertyFromStatusDescripton = (index: number, gqlStatusDescription?: string): string | undefined => {
  const matches = gqlStatusDescription?.match(/^(?:(?:error|info|warn):\s)?([\s\S]+?)(?:\.([\s\S]+?))?\.?$/) ?? [];
  return matches[index] === undefined ? undefined : std.Strings.capitalize(matches[index].trim());
};

export const formatDescriptionFromGqlStatusDescription = (gqlStatusDescription: string): string => {
  const description =
    formatPropertyFromStatusDescripton(GQL_STATUS_INDEXES.description, gqlStatusDescription)?.trim() ?? '';
  return std.isNonEmptyString(description) && !description.endsWith('.') ? `${description}.` : description;
};

export const formatTitleFromGqlStatusDescription = (gqlStatus: string, gqlStatusDescription: string): string => {
  const title = formatPropertyFromStatusDescripton(GQL_STATUS_INDEXES.title, gqlStatusDescription)?.trim() ?? '';
  const description = formatDescriptionFromGqlStatusDescription(gqlStatusDescription);

  if (std.isNonEmptyString(title) && title !== gqlStatus) {
    return `${gqlStatus}: ${title}`;
  } else if (std.isNonEmptyString(description)) {
    return `${gqlStatus}: ${description}`;
  }

  return gqlStatus;
};
